// extracted by mini-css-extract-plugin
export default {"container":"desc_container__jzypz","title":"desc_title__rBdmx","render":"desc_render__DXtG7","mesh":"desc_mesh__Sh2JL"};